const totalClasses = Object.freeze({
    DEFAULT: 'default',
    UNDER: 'total-under',
    EQUAL: 'total-equal',
    OVER: 'total-over',
});

export const getTotalBemClass = (par = null) => {
    if (par === null) return totalClasses.DEFAULT;

    if (Number(par) < 0) {
        return totalClasses.UNDER;
    }

    if ((Number(par) === 0) || par === 'E') {
        return totalClasses.EQUAL;
    }

    if (Number(par) > 0) {
        return totalClasses.OVER;
    }

    return totalClasses.DEFAULT;
};

const todayClasses = Object.freeze({
    DEFAULT: 'default',
    UNDER: 'today-under',
    EQUAL: 'today-equal',
    OVER: 'today-over',
});

export const getTodayBemClass = (par = null) => {
    if (par === null) return todayClasses.DEFAULT;

    if (Number(par) < 0) {
        return todayClasses.UNDER;
    }

    if ((Number(par) === 0) || par === 'E') {
        return todayClasses.DEFAULT;
    }

    if (Number(par) > 0) {
        return todayClasses.OVER;
    }

    return todayClasses.DEFAULT;
};


const holeParClasses = Object.freeze({
    DEFAULT: 'default',
    UNDER_TWO: 'hole-under-two',
    UNDER: 'hole-under',
    EQUAL: 'hole-equal',
    OVER: 'hole-over',
});

export const getHoleParBemClass = (holePar, playerPar) => {
    if (!holePar ||
        playerPar === null ||
        playerPar === 0 ||
        playerPar === '-'
    ) {
        return holeParClasses.DEFAULT;
    }

    const holeParNum = Number(holePar);
    const playerParNum = Number(playerPar);

    if (holeParNum - playerParNum >= 2) {
        return holeParClasses.UNDER_TWO;
    }

    if (holeParNum - playerParNum === 1) {
        return holeParClasses.UNDER;
    }

    if (holeParNum - playerParNum === 0) {
        return holeParClasses.EQUAL;
    }

    if (holeParNum - playerParNum < 0) {
        return holeParClasses.OVER;
    }

    return holeParClasses.DEFAULT;
};


export const getHoleParBemClassForCustomEvent = (holePar, playerPar) => {
    if (!holePar ||
        playerPar === null ||
        playerPar === 0 ||
        playerPar === '-'
    ) {
        return holeParClasses.DEFAULT;
    }

    if(playerPar === 'E')
        return holeParClasses.EQUAL;

    if(Number(playerPar) <= -2)
        return holeParClasses.UNDER_TWO;
    
    if(Number(playerPar) === -1)
        return holeParClasses.UNDER;

    if(Number(playerPar) > 0)
        return holeParClasses.OVER;

    return holeParClasses.DEFAULT;
};

export const getHoleParBemClassForCustomEventPointsBased = (holePar, playerScore) => {
    if (!holePar || playerScore === null || playerScore === '-') {
        return holeParClasses.DEFAULT;
    }

    if (playerScore >= 4) {
        return holeParClasses.UNDER_TWO;
    }

    if (playerScore === 3) {
        return holeParClasses.UNDER;
    }

    if (playerScore === 2) {
        return holeParClasses.EQUAL;
    }

    if (playerScore === 1 || playerScore === 0) {
        return holeParClasses.OVER;
    }

    return holeParClasses.DEFAULT;
};
